import { UntrustedApi } from "../untrustedApi";

export type ProviderHandler = UntrustedApi & { isReady: boolean; isReal: boolean; isServerSide?: boolean };

export enum HandlerType {
  TRUSTED_API = "TRUSTED_API",
  UNTRUSTED_PROVIDER_API = "provider",
}
